import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  BodyBold,
  Body,
} from 'ggx-componentlibrary/design/typography/typography.styles'
import { DriverNotesContainer } from 'ggx-src/order-management/order-detail-1/shipping-info/shipping-info.component.styles.js'

const PackageContentBlockInDetail = ({ order }) => {
  const packageContent = order?.order_request_extra?.package_content

  const [t] = useTranslation()
  let text = t(`vn_contents__${packageContent}`)
  text = text === `vn_contents__${packageContent}` ? packageContent : text

  return packageContent ? (
    <DriverNotesContainer>
      <BodyBold noMargin style={{ marginBottom: '12px' }}>
        {t('transport_content')}
      </BodyBold>
      <Body noMargin>{text}</Body>
    </DriverNotesContainer>
  ) : null
}

export { PackageContentBlockInDetail }
